import React, { useState } from 'react';
import EyeIcon from 'svg/EyeIcon';
import Header from 'screens/TournamentDetails/Register/Header';
import FormSignup from 'components/forms/FormSignup';
import { RegisterProps, Steps } from '../types';

export default function CreateAccount({ setSteps, handleNext }: RegisterProps) {
  return (
    <div className="tournament-register-form h-full overflow-y-auto px-6 py-5">
      <div className="flex">
        <Header title="Register" cta="Create an account" />
      </div>
      <div className="mt-2 h-full">
        <FormSignup
          isFormOnly
          isShowLoginLink
          shouldSkipReload
          formWrapperClassName="pb-8 pt-1 px-1"
          buttonWrapperClassName="px-6 pb-6"
          spacerClassName="space-y-6"
          toggleLogin={() => setSteps(Steps.Login)}
          handleAuthComplete={() => handleNext()}
        />
      </div>
    </div>
  );
}
